import React from "react";
import { View } from "react-native";

import CustomText from "../../common/general/CustomText/CustomText";
import CustomSpacing from "../../common/layout/CustomSpacing/CustomSpacing";

type GradingCenterHeaderProps = object;

const GradingCenterHeader: React.FC<GradingCenterHeaderProps> = () => {
  return (
    <View>
      <CustomText
        text="Grading Center"
        textType="display"
        weight="ultraBold"
        role="heading"
        aria-level="1"
        style={{ color: "#101828" }}
      />

      <CustomSpacing size="s" />

      <CustomText text="Review and grade student submissions across all your courses" style={{ color: "#667085" }} />

      <CustomSpacing size="xl" />
    </View>
  );
};

export default GradingCenterHeader;
